// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const WorkspacesIcon = createSvgIcon(
  <svg fill="currentColor" viewBox="0 0 24 24">
    <path d="M20 6.7v5.5h-3V6.7zm-6.5 0v2.5h-3V6.7zM7 6.7v10.6H4V6.7zm6.5 6v4.6h-3v-4.6zm6.5 3v1.6h-3v-1.6zm.6-10h-4.2a.4.4 0 0 0-.4.43v6.64a.4.4 0 0 0 .4.43h4.2a.4.4 0 0 0 .4-.43V6.13a.4.4 0 0 0-.4-.43m-6.5 0H9.9a.4.4 0 0 0-.4.43v3.64a.4.4 0 0 0 .4.43h4.2a.4.4 0 0 0 .4-.43V6.13a.4.4 0 0 0-.4-.43m-6.5 0H3.4a.4.4 0 0 0-.4.43v11.74a.4.4 0 0 0 .4.43h4.2a.4.4 0 0 0 .4-.43V6.13a.4.4 0 0 0-.4-.43m6.5 6H9.9a.4.4 0 0 0-.4.43v5.74a.4.4 0 0 0 .4.43h4.2a.4.4 0 0 0 .4-.43v-5.74a.4.4 0 0 0-.4-.43m6.5 3h-4.2a.4.4 0 0 0-.4.43v2.74a.4.4 0 0 0 .4.43h4.2a.4.4 0 0 0 .4-.43v-2.74a.4.4 0 0 0-.4-.43" />
  </svg>,
  "Workspaces",
);
export default WorkspacesIcon;
